// @spec health-page
'use client';

import { useSyncExternalStore } from 'react';

/** Client snapshot for `useSyncExternalStore` — reads the current document visibility state. */
function getSnapshot(): boolean {
  return document.visibilityState === 'visible';
}

/** SSR snapshot for `useSyncExternalStore` — assumes visible so server-rendered markup matches the common case. */
function getServerSnapshot(): boolean {
  return true;
}

/** Subscribes to `visibilitychange` events for `useSyncExternalStore`. */
function subscribe(callback: () => void): () => void {
  document.addEventListener('visibilitychange', callback);
  return () => document.removeEventListener('visibilitychange', callback);
}

/**
 * Returns true when the document is visible (the tab is foregrounded), false
 * when hidden (backgrounded, minimized, or in another tab). Returns `true`
 * during SSR / before hydration since {@link getServerSnapshot} assumes visible.
 */
export function useDocumentVisible() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}